// Mock data for Credora Capital website

export const companyInfo = {
  name: "Credora Capital",
  tagline: "Unlocking India's Emerging Equity Potential",
  parentEntity: "Greenflow Ventures Pvt Ltd",
  fundType: "Category I AIF (under SEBI AIF Regulations, 2012)",
  vision: "To unlock India's emerging equity potential through structured, data-driven, and regulation-aligned investments.",
  mission: "To capitalize on the surge in SME and Mainboard IPO participation by offering structured, data-driven, and regulation-aligned investment opportunities."
};

export const services = [
  {
    title: "Anchor Investing",
    description: "Leveraging preferential allocations in Mainboard IPOs for early exposure, potential immediate listing gains, and post-lock-in upside.",
    icon: "target"
  },
  {
    title: "SME IPO Participation", 
    description: "Focused investments in high-growth potential SMEs with less competitive institutional coverage.",
    icon: "trending-up"
  },
  {
    title: "Pre-IPO Rounds",
    description: "Backing scalable businesses that are 12-36 months away from public listing.",
    icon: "rocket"
  },
  {
    title: "Early-Stage Startups",
    description: "Opportunistic allocation to promising startups with credible teams, strong traction, and near-term listing roadmaps.",
    icon: "spark"
  }
];

export const keyMetrics = [
  {
    value: "₹1000 Cr",
    label: "Minimum AUM Target",
    description: "Initial close with greenshoe option"
  },
  {
    value: "5+ Years",
    label: "Investment Horizon",
    description: "Medium to long-term strategy"
  },
  {
    value: "₹1 Cr",
    label: "Minimum Investment",
    description: "For qualified investors"
  },
  {
    value: "400+",
    label: "IPOs Since 2020",
    description: "Raising over ₹1.25 lakh crore"
  }
];

export const teamMember = {
  name: "Shubham Gupta",
  role: "Lead Fund Manager & Investment Strategist",
  experience: "Over 10 years of direct experience in primary and secondary markets",
  specialization: "IPO investing and SME equity",
  background: "Former banker and educator under the brand Investorniti"
};

export const fundDetails = {
  structure: "Close-ended fund",
  tenure: "7 to 8 years, with possibility of extension",
  managementFee: "3% per annum of committed capital",
  hurdleRate: "12% per annum preferred return",
  lockIn: "3 years from capital deployment",
  reporting: "Quarterly NAV calculations and transparent reporting"
};

export const marketContext = [
  "Over 400 IPOs launched in India since FY 2020",
  "SME exchanges showing 25%+ CAGR growth", 
  "Anchor investors consistently outperform retail",
  "Growing institutional participation in primary markets"
];